import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M11.118 7.41L5.687 1.98l-.707.707L10.293 8 4.98 13.313l.707.707 5.43-5.431a.833.833 0 000-1.178z",
    fill: "#000",
    fillOpacity: 0.65
  }));
}
export default SvgComponent;